import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-526c052a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "data-inconsistency-header" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-database-18px data-inconsistency-header__icon" }, null, -1));
const _hoisted_3 = { class: "data-inconsistency-header__title" };
const _hoisted_4 = { class: "data-inconsistency-header__text" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-download-14px" }, null, -1));
import { ref, computed, toRefs } from 'vue';
import moment from 'moment';
import FileDownload from 'js-file-download';
import { useStore } from 'vuex';
// utils
import { useMixpanelDataInconsistency } from '@/utilities/mixpanel';
// services
import { exportDataInconsistency } from '@/features/DataInconsistency/services';
import { exportDateFormat } from '@/utilities/constants';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistencyHeader',
    props: {
        showButtonExport: { type: Boolean }
    },
    emits: ['isLoadingExport'],
    setup(__props, { emit }) {
        const props = __props;
        // lib
        const store = useStore();
        const isToggleText = ref(false);
        const showBtnText = computed(() => {
            const showMore = 1;
            const showLess = 2;
            return isToggleText.value ? showLess : showMore;
        });
        const selectedBrand = computed(() => store.state.auth.selectedBrand.brand);
        const toggleText = () => {
            isToggleText.value = !isToggleText.value;
            useMixpanelDataInconsistency(`view_integrations_data_inconsistency_click_${isToggleText.value ? 'view_more' : 'view_less'}`);
        };
        const fetchExportData = (fileType) => {
            const featureName = 'Inconsistência de Dados';
            emit('isLoadingExport', true);
            useMixpanelDataInconsistency('view_integrations_data_inconsistency_click_export');
            exportDataInconsistency(fileType, 'blob')
                .then(response => {
                const date = moment().format(exportDateFormat);
                FileDownload(response, `${featureName} - ${selectedBrand.value} - ${date}.${fileType}`);
            })
                .finally(() => {
                emit('isLoadingExport', false);
            });
        };
        const { showButtonExport } = toRefs(props);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("header", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('integrations.data-inconsistency.title')), 1),
                    _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('integrations.data-inconsistency.show-less-text', {
                            viewMore: isToggleText.value ? _ctx.$t('integrations.data-inconsistency.show-more-text') : '',
                        })), 1),
                        _createElementVNode("strong", {
                            "data-cy": "data-inconsistency-status-text",
                            onClick: toggleText
                        }, _toDisplayString(_ctx.$tc('_see-more-or-less', showBtnText.value)), 1)
                    ])
                ]),
                (_unref(showButtonExport))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn data-inconsistency-header__btn-export",
                        onClick: _cache[0] || (_cache[0] = ($event) => (fetchExportData('csv'))),
                        "data-cy": "data-inconsistency-export-btn"
                    }, [
                        _hoisted_5,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('integrations.data-inconsistency.btn-export')), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
